/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

export type PlaceOrderDtoType = (typeof PlaceOrderDtoType)[keyof typeof PlaceOrderDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaceOrderDtoType = {
  limit: 'limit',
  market: 'market',
} as const;
